<ng-container bbTransactionSigningHeaderCustomizable
              [bbHostRef]="hostRef"></ng-container>
<ng-template bbTransactionSigningHeaderCustomizable
             let-hostRef>
  <ng-container [ngSwitch]="hostRef.data['confirmation-type']">
    <div *ngSwitchCase="'initiate-payment'">
      <bb-header-ui headingType="h2"
                    i18n-heading="Transaction signing modal title for initiate-payment@@bb-transaction-signing-header.initiate-payment.title"
                    heading="Verification code">
      </bb-header-ui>
      <!-- <div
        data-role="ts-modal-subtitle"
        i18n="Transaction signing modal sub-title for initiate-payment@@bb-transaction-signing-header.initiate-payment.sub-title">
        Send
        <bb-amount-ui
          [currency]="hostRef.data.currency"
          [amount]="hostRef.data.amount">
        </bb-amount-ui>
        to {{ hostRef.data['counter-party-name'] }}.
      </div> -->
    </div>
    <div *ngSwitchCase="'approve-payment'">
      <bb-header-ui headingType="h2"
                    i18n-heading="Transaction signing modal title for approve-payment@@bb-transaction-signing-header.approve-payment.title"
                    heading="Authorisation">
      </bb-header-ui>
      <div data-role="ts-modal-subtitle"
           i18n="Transaction signing modal sub-title for approve-payment@@bb-transaction-signing-header.approve-payment.sub-title">
        Approve payment of
        <bb-amount-ui [currency]="hostRef.data.currency"
                      [amount]="hostRef.data.amount">
        </bb-amount-ui>
        to {{ hostRef.data['counter-party-name'] }}.
      </div>
    </div>
  </ng-container>
</ng-template>
